<mat-card appearance="outlined" class="font-size-16 brain-card impostazioni-form-card">
  <mat-card-content>
    @if (urlImgProfilo) {
      <div class="current-profile-photo">
        <p>Foto attuale</p>
        <div class="current-profile-photo-image">
          <img [src]="urlImgProfilo" alt="Foto profilo attuale" />
          <button
            mat-icon-button
            type="button"
            class="current-profile-photo-remove"
            aria-label="Elimina foto profilo"
            matTooltip="Elimina foto profilo"
            [disabled]="isUploading"
            (click)="eliminaFoto()"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
    @if (isSaved) {
      <p class="service-callout" role="status">Immagine del profilo aggiornata.</p>
    }
    <mat-stepper [linear]="true" [orientation]="stepperOrientation" #stepper>
      <mat-step [editable]="isStep1ok" [completed]="isStep1ok">
        <ng-template matStepLabel>Seleziona</ng-template>

        <div class="flex-h mb-24">
          <button
            type="button"
            aria-label="Seleziona una foto o trascinala qui"
            class="my-drop-zone pointer"
            [class.dragging]="isDragging"
            (click)="uploadFoto.click()"
            (dragover)="$event.preventDefault(); isDragging = true"
            (dragleave)="isDragging = false"
            (drop)="onFileDrop($event)"
          >
            <p>
              <mat-icon class="mat-24">insert_drive_file</mat-icon>
              <br />
              <br />
              <span>Seleziona la foto</span>
              <br />
              <span>Oppure trascinala qui</span>
            </p>
          </button>
        </div>
        <div class="none">
          <input type="file" #uploadFoto [accept]="allowedMimeType.join(',')" (change)="onChangeFile($event)" />
        </div>
        @if (uploadError) {
          <p class="service-callout service-callout--error" role="alert">{{ uploadError }}</p>
        }
      </mat-step>

      <mat-step [editable]="isStep2ok" [completed]="isStep2ok">
        <ng-template matStepLabel>Ritaglia</ng-template>

        <div class="flex-h">
          @if (imgPreview) {
            <image-cropper
              [imageBase64]="imgPreview"
              [maintainAspectRatio]="true"
              [aspectRatio]="1 / 1"
              [resizeToWidth]="400"
              [cropperMinWidth]="128"
              [roundCropper]="true"
              [autoCrop]="false"
              (imageCropped)="imageCropped($event)"
            ></image-cropper>
          }
        </div>

        <div class="action-buttons step-two-action-buttons">
          <div>
            <button mat-icon-button aria-label="Ruota a sinistra" (click)="rotatePreview('left')">
              <mat-icon>rotate_left</mat-icon>
            </button>
            <button mat-icon-button aria-label="Ruota a destra" (click)="rotatePreview('right')">
              <mat-icon>rotate_right</mat-icon>
            </button>
          </div>
          <div>
            <button matButton="outlined" (click)="stepper.previous()">Indietro</button>
            <button matButton="filled" class="ml-16 service-primary-action" (click)="crop()">Continua</button>
          </div>
        </div>
      </mat-step>

      <mat-step [editable]="false">
        <ng-template matStepLabel>Conferma</ng-template>

        <div class="flex-h">
          <div class="img-wrapper">
            @if (croppedImage) {
              <img [src]="croppedImage" />
            }
          </div>
        </div>

        <div class="action-buttons">
          <span></span>
          <div>
            <button matButton="outlined" (click)="stepper.previous()">Indietro</button>
            <button
              matButton="filled"
              class="ml-16 service-primary-action"
              [disabled]="isUploading"
              (click)="uploadProfilo()"
            >
              {{ isUploading ? 'Salvataggio…' : 'Salva' }}
            </button>
          </div>
        </div>
        @if (uploadError) {
          <p class="service-callout service-callout--error" role="alert">{{ uploadError }}</p>
        }
      </mat-step>
    </mat-stepper>
  </mat-card-content>
</mat-card>
